/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Status_Box_DisconnectedInputs */



/**
* | output |
* | --- |
* | "Box disconnected" |
*
* @param {Module_Settings_Status_Box_DisconnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_box_disconnected = /** @type {((inputs?: Module_Settings_Status_Box_DisconnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_Box_DisconnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Box disconnected")
	return /** @type {LocalizedString} */ ("Box déconnectée")
});